<!--
 * @Copyright: 中国信息安全测评中心
 * @Author: xiaowenwen
 * @Date: 2021-03-02 11:50:32
 * @LastEditTime: 2021-08-06 11:17:32
 * @Description: 
-->
<template>
  <span>{{ message }}</span>
</template>

<script>
import HOME from "@/api/sync/home";
import axios from "axios";

export default {
  name: "ldap-test",
  props: { ldap: { type: Object } },
  data() {
    return {
      state: undefined
    };
  },
  computed: {
    message: vm =>
      vm.state === undefined
        ? "正在测试LDAP连接..."
        : `LDAP连接${vm.state ? "成功" : "失败"}。`
  },
  async created() {
    this.source = axios.CancelToken.source();
    let response = await HOME.LDAP_CONNECTION_TEST(
      { ldap: this.ldap },
      { cancelToken: this.source.token }
    );
    this.state = response.data?.state;
    if (this.state === false) {
      console.log("连接失败原因：");
      console.dir(response.data.message);
    }
  },
  destroyed() {
    this.source.cancel("连接测试取消");
  }
};
</script>

<style scoped></style>
